import { createContext, useContext } from "react";

import { DEFAULT_THEME } from "@vega-core/constants/global";
import { type ThemeContextType } from "@vega-core/context/ThemeContext/types";
import { type ThemesList } from "@vega-core/themeConfig/themesModel";

export const useTheme = () => useContext(ThemeContext);

export const ThemeContext = createContext<ThemeContextType>({
  changeTheme: (theme: ThemesList) => theme,
  setUseSystemTheme: () => {},
  theme: DEFAULT_THEME,
  useSystemTheme: false,
});
